import { render, staticRenderFns } from "./SetUpProviderModal.vue?vue&type=template&id=41196232&scoped=true&"
import script from "./SetUpProviderModal.vue?vue&type=script&lang=js&"
export * from "./SetUpProviderModal.vue?vue&type=script&lang=js&"
import style0 from "./SetUpProviderModal.vue?vue&type=style&index=0&id=41196232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41196232",
  null
  
)

export default component.exports